export default {
  pageTitle: 'Sales Order Detail',
  secondTitle: 'Order Information',
  remark: 'Remark',
  userConfirmed: 'User Confirmed',
  pendingConfirm: 'Pending User Confirm',
  areaTitle: 'New Order Confirmation',
  Confirmed1: 'Confirmed With Customer',
  Confirmed2: 'Confirmed With Customer(Only send goods in stock)',
  Confirmed3: 'Waiting for all goods to be ready',
  Confirmed4: 'Customer Cancelled',
  ok: 'OK',
  cancelOrderReason: 'Please select the reason for cancellation first!',
  orderOperationLog: 'Order Operation Log',
  noLogisticsRecord: 'No logistics record.',
  cancelConfirmation: 'Cancel confirmation',
  confirmCancelOrder: 'Order will be cancelled, do you want to continue ?',
  cancelOrder: 'Cancel Order',
  paymentMethodMap1: 'Online',
  paymentMethodMap2: 'COD',
  paymentMethodMap3: 'Pre',
  // -------------------------------------------
  packageStatusMap1: 'Pending Dispatch',
  packageStatusMap2: 'In Transit',
  packageStatusMap3: 'In Delivery',
  packageStatusMap4: 'Completed',
  packageStatusMap5: 'Rejected',
  packageStatusMap6: 'Cancel',
  packageStatusMap7: 'Back',
  // ----------------------------------------------
  shipOrderStatusMap1: 'Collecting Goods',
  shipOrderStatusMap2: 'Collection Completed',
  shipOrderStatusMap3: 'Packaged',
  shipOrderStatusMap4: 'In Transit',
  shipOrderStatusMap5: 'In Delivery',
  shipOrderStatusMap6: 'Completed',
  shipOrderStatusMap7: 'Rejected',
  shipOrderStatusMap8: 'Cancel',
  // -------------------------------------------
  saleOrderStatusMap1: 'Pending Payment',
  saleOrderStatusMap2: 'Pending Confirmation',
  saleOrderStatusMap3: 'Pending Dispatch',
  saleOrderStatusMap4: 'In Transit',
  saleOrderStatusMap5: 'All received',
  saleOrderStatusMap6: 'Restocking',
  saleOrderStatusMap7: 'Cancel',
  saleOrderStatusMap8: 'Rejected',
  saleOrderStatusMap9: 'Partially Received',
  // ------------------------------------
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  // ----------------------------------------
  operateTypeList1: 'Place',
  operateTypeList2: 'Pay',
  operateTypeList3: 'Confirm',
  operateTypeList4: 'Dispatch',
  operateTypeList5: 'Arrive Trans Center',
  operateTypeList6: 'Clearance',
  operateTypeList7: 'Arrive Local Center',
  operateTypeList8: 'Packaged',
  operateTypeList9: 'Delievery',
  operateTypeList10: 'Received',
  operateTypeList11: 'close',
  operateTypeList12: 'Cancel',
  operateTypeList13: 'Rejected',
  // --------------------------------------------
  operatorIdList1: 'Buyer',
  operatorIdList2: 'Seller',
  operatorIdList3: 'Marketplace',
  operatorIdList4: 'Logistics',
  operatorIdList5: 'Marketplace',
  // ---------------------------------------------
  time: 'Time',
  operation: 'Operation',
  operatorId: 'Operator ID',
  from: 'From',
  so: 'SO#',
  payment: 'Payment',
  paymentStatus: 'Payment Status',
  unpaid: 'Unpaid',
  paid: 'paid',
  userId: 'UserID',
  contactPhone: 'Contact Phone',
  orderTime: 'Order Time',
  amount: 'Item Total',
  discount: 'Discount',
  postage: 'Postage',
  coinsRedeem: 'Coins',
  voucherRedeem: 'Voucher',
  oldStatus: 'Old Status',
  status: 'Status',
  // -----------------------------------
  columnShipInfo1: 'Ship Order#',
  columnShipInfo2: 'Ship Order Serial',
  columnShipInfo3: 'Ship Order Status',
  damaged: 'Damaged',
  discrepancy: 'Discrepancy',
  noReason: 'No reason',
  columnShipInfo4: 'Package#',
  columnShipInfo5: 'Package Serial',
  columnShipInfo6: 'Package Status',
  columnShipInfo7: 'Package Created Time',
  // -------------------------------------------
  columnOder1: 'SaleOrderCode',
  columnOder2: 'Order Amount',
  columnOder3: 'Receiver',
  columnOder4: 'Country',
  columnOder5: 'State',
  total: 'Total',
  due: 'Due',
  columnOder6: 'City',
  columnOder7: 'Area',
  columnOder8: 'Address',
  columnOder9: 'Contact Phone',
  // --------------------------------------
  tableColumnSku1: 'Sku Id',
  tableColumnSku2: 'Manufacture Id',
  tableColumnSku3: 'Deal Price',
  tableColumnSku4: 'Sale Price',
  tableColumnSku5: 'Count',
  tableColumnSku6: 'Avail',
  tableColumnSku7: 'Amount',
  tableColumnSku8: 'Discount',
  tableColumnSku9: 'Coins Redeem',
  tableColumnSku10: 'Voucher Redeem',
  tableColumnSku11: 'Title',
  tableColumnSku12: 'Spec',
  tableColumnSku13: 'Weight',
  tableColumnSku14: 'Vendor',
  // ---------------------------------
  errorTips1: '该商品从Dhaka退货仓发货，由Kilimall代处理',
  warningTips1: '【2252】SMS failed to send.',
  warningTips2: '【2252】SMS turned off.',
  successTips1: 'SMS sent successfully.',
  delivered: 'Goods being delivered by',
  orderTrack: 'Order Track'
}
